import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material'
import type { AthleteProfileFormApi } from '../../../hooks/useAthleteProfileForm'

/** Academic info fields, shared by the onboarding wizard and the edit form. */
export const AcademicInfoFields = ({ form }: { form: AthleteProfileFormApi }) => {
  const { data, fieldErrors, setData, validateAcademicField, schoolYearOptions } = form

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label="High School"
          value={data.academicInfo.highSchool}
          error={!!fieldErrors['academicInfo.highSchool']}
          helperText={fieldErrors['academicInfo.highSchool']}
          onChange={e => {
            const next = { ...data.academicInfo, highSchool: e.target.value }
            setData({ ...data, academicInfo: next })
            validateAcademicField('highSchool', 'academicInfo.highSchool', next)
          }}
          onBlur={() =>
            validateAcademicField('highSchool', 'academicInfo.highSchool', data.academicInfo)
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth required error={!!fieldErrors['academicInfo.graduationYear']}>
          <InputLabel>Graduation year</InputLabel>
          <Select
            value={data.academicInfo.graduationYear}
            label="Graduation year"
            onChange={e => {
              const next = { ...data.academicInfo, graduationYear: e.target.value as string }
              setData({ ...data, academicInfo: next })
              validateAcademicField('graduationYear', 'academicInfo.graduationYear', next)
            }}
            onBlur={() =>
              validateAcademicField(
                'graduationYear',
                'academicInfo.graduationYear',
                data.academicInfo
              )
            }
          >
            <MenuItem value="">
              <em>Select a year</em>
            </MenuItem>
            {schoolYearOptions.map(y => (
              <MenuItem key={y} value={String(y)}>
                {y}
              </MenuItem>
            ))}
          </Select>
          {fieldErrors['academicInfo.graduationYear'] && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, mx: 1.75 }}>
              {fieldErrors['academicInfo.graduationYear']}
            </Typography>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          required
          label="GPA"
          type="number"
          inputProps={{ step: 0.01, min: 0, max: 4.0 }}
          value={data.academicInfo.gpa}
          error={!!fieldErrors['academicInfo.gpa']}
          helperText={fieldErrors['academicInfo.gpa']}
          onChange={e => {
            const next = { ...data.academicInfo, gpa: e.target.value }
            setData({ ...data, academicInfo: next })
            validateAcademicField('gpa', 'academicInfo.gpa', next)
          }}
          onBlur={() => validateAcademicField('gpa', 'academicInfo.gpa', data.academicInfo)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="SAT Score (Optional)"
          type="number"
          inputProps={{ min: 400, max: 1600 }}
          value={data.academicInfo.satScore}
          error={!!fieldErrors['academicInfo.satScore']}
          helperText={fieldErrors['academicInfo.satScore']}
          onChange={e => {
            const next = { ...data.academicInfo, satScore: e.target.value }
            setData({ ...data, academicInfo: next })
            validateAcademicField('satScore', 'academicInfo.satScore', next)
          }}
          onBlur={() =>
            validateAcademicField('satScore', 'academicInfo.satScore', data.academicInfo)
          }
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="ACT Score (Optional)"
          type="number"
          inputProps={{ min: 1, max: 36 }}
          value={data.academicInfo.actScore}
          error={!!fieldErrors['academicInfo.actScore']}
          helperText={fieldErrors['academicInfo.actScore']}
          onChange={e => {
            const next = { ...data.academicInfo, actScore: e.target.value }
            setData({ ...data, academicInfo: next })
            validateAcademicField('actScore', 'academicInfo.actScore', next)
          }}
          onBlur={() =>
            validateAcademicField('actScore', 'academicInfo.actScore', data.academicInfo)
          }
        />
      </Grid>
    </Grid>
  )
}
